import { TANJA_DELL_LOGO_PUBLIC_URL } from '../../constants/brandAssets';

export interface SeminarInviteMailInput {
  email: string;
  name?: string;
  seminarUrl: string;
  seminarPassword?: string;
  origin?: string;
}

export interface SeminarInviteMailContent {
  subject: string;
  text: string;
  html: string;
}

const esc = (value: string): string =>
  String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

export function resolveCutierMailOrigin(origin?: string): string {
  if (origin && origin.trim()) return origin.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) return window.location.origin;
  return 'https://pe-one-app.web.app';
}

export function buildSeminarInviteMail(input: SeminarInviteMailInput): SeminarInviteMailContent {
  const normalizedEmail = String(input.email || '').toLowerCase().trim();
  const name = String(input.name || '').trim();
  const greeting = name ? `Hallo ${name},` : 'Hallo,';
  const seminarUrl = String(input.seminarUrl || '').trim();
  const seminarPassword = String(input.seminarPassword || '').trim();
  const tanjaLogo = TANJA_DELL_LOGO_PUBLIC_URL;
  const doiUrl = `https://preis-expert.de/newsletter/opt-in?email=${encodeURIComponent(normalizedEmail)}&source=cutier_hub`;

  const subject = 'Lockenzeremonie & CUTIER — dein Seminar-Zugang';

  const passwordText = seminarPassword
    ? `\nZugangspasswort: ${seminarPassword}\n`
    : '';

  const text = `${greeting}

vielen Dank für deine Teilnahme am Online-Seminar von Lockenzeremonie & CUTIER.

Dein Zugangslink:
${seminarUrl}
${passwordText}
Mehr als ein Newsletter — die PreisExpert Branchen-Insights:
Preisgestaltung, Mitarbeiterführung, Marketing und Unternehmenszahlen. Wissen aus über 200 betreuten Salons. Kostenlos. Praxisnah. Ehrlich.
Hier anmelden: ${doiUrl}

Herzliche Grüße
Dein Team von CUTIER & ramin dell luxury hair

Fragen zum Seminar? Einfach auf Antworten klicken — deine Nachricht geht direkt an rd@ramindell.com.`;

  const passwordBlock = seminarPassword
    ? `
      <tr>
        <td style="padding: 0 32px 8px 32px;">
          <p style="margin: 0 0 8px 0; font-size: 12px; letter-spacing: 0.12em; text-transform: uppercase; color: #94a3b8;">Zugangspasswort</p>
          <div style="background: #111111; border: 1px solid #E6C299; border-radius: 12px; padding: 14px 18px; text-align: center;">
            <span style="font-size: 20px; font-weight: 800; letter-spacing: 0.18em; color: #E6C299;">${esc(seminarPassword)}</span>
          </div>
        </td>
      </tr>
    `
    : '';

  // 1600×854-Banner: ohne width/height-Attribute rendern Mail-Clients die volle Höhe (schwarze Wand).
  const html = `
  <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="font-family:Arial,Helvetica,sans-serif;color:#1e293b;">
    <tr>
      <td align="center" style="padding:0;">
        <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="560" style="max-width:560px;width:100%;background:#0a0a0a;border:1px solid #333333;border-radius:12px;overflow:hidden;">
            <tr>
              <td align="center" style="background:#050505;padding:16px 20px 12px 20px;">
                <img src="${tanjaLogo}" alt="Tanja Dell Lockenzeremonie" width="400" height="214" style="display:block;width:400px;max-width:100%;height:auto;margin:0 auto;border:0;" />
                <p style="margin:10px 0 0 0;font-size:11px;letter-spacing:0.16em;text-transform:uppercase;color:#E6C299;">Exklusiver Seminar-Zugang</p>
              </td>
            </tr>
            <tr>
              <td style="height:3px;background:#E6C299;font-size:0;line-height:0;">&nbsp;</td>
            </tr>
            <tr>
              <td style="padding:28px 32px 8px 32px;">
                <p style="margin:0 0 12px 0;font-size:16px;color:#ffffff;">${esc(greeting)}</p>
                <p style="margin:0;font-size:15px;line-height:1.7;color:#cbd5e1;">vielen Dank für deine Teilnahme. Über den Button gelangst du direkt zum Online-Seminar von <strong style="color:#ffffff;">Lockenzeremonie</strong> &amp; <strong style="color:#ffffff;">CUTIER</strong>.</p>
              </td>
            </tr>
            <tr>
              <td style="padding:20px 32px;" align="center">
                <a href="${esc(seminarUrl)}" style="display:inline-block;background:#E6C299;color:#030303;text-decoration:none;font-weight:800;font-size:13px;letter-spacing:0.08em;text-transform:uppercase;padding:14px 28px;border-radius:12px;">Zum Seminar-Zugang</a>
              </td>
            </tr>
            ${passwordBlock}
            <tr>
              <td style="padding:8px 32px 24px 32px;">
                <p style="margin:0;font-size:12px;line-height:1.6;color:#64748b;word-break:break-all;">Link: ${esc(seminarUrl)}</p>
              </td>
            </tr>
            <tr>
              <td style="padding:0 32px;">
                <div style="border-top:1px solid #333333;"></div>
              </td>
            </tr>
            <tr>
              <td style="padding:26px 32px 6px 32px;">
                <p style="margin:0 0 8px 0;font-size:18px;font-weight:700;color:#E6C299;">Mehr als ein Newsletter.</p>
                <p style="margin:0 0 12px 0;font-size:13px;line-height:1.75;color:#94a3b8;">Impulse, die deinen Salon erfolgreicher machen &mdash; von Preisgestaltung &uuml;ber Mitarbeiterf&uuml;hrung bis zu Marketing, Social Media und Unternehmenszahlen. Wir teilen unser Wissen aus &uuml;ber 200 betreuten Salons.</p>
                <p style="margin:0;font-size:11px;letter-spacing:0.16em;text-transform:uppercase;color:#E6C299;">Kostenlos &middot; Praxisnah &middot; Ehrlich</p>
              </td>
            </tr>
            <tr>
              <td style="padding:16px 32px 28px 32px;">
                <a href="${esc(doiUrl)}" style="display:inline-block;border:1px solid #E6C299;color:#E6C299;font-size:12px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;text-decoration:none;padding:11px 20px;border-radius:10px;">Ja, ich m&ouml;chte die Branchen-Insights</a>
              </td>
            </tr>
            <tr>
              <td style="padding:16px 32px 28px 32px;background:#050505;border-top:1px solid #333333;">
                <p style="margin:0;font-size:11px;line-height:1.5;color:#64748b;">Tanja Dell Lockenzeremonie<br/>CUTIER by Herzinger Schneidepartner GmbH · ramin dell luxury hair<br/>Fragen? Einfach antworten — deine Nachricht geht direkt an <a href="mailto:rd@ramindell.com" style="color:#E6C299;text-decoration:underline;">rd@ramindell.com</a></p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>`.trim();

  return { subject, text, html };
}
